import { VStack } from '@chakra-ui/react';
import StoreItems from '~/components/StoreItems';
import { CartType } from '~/types/cart';

import { StoreOrderInPlatform } from '~/types/order';

type OrderItemListProps = {
  cartType: CartType;
  orders: Array<StoreOrderInPlatform>;
};

export default function OrderItemList({ cartType, orders }: OrderItemListProps) {
  return (
    <VStack align="stretch" spacing={4}>
      {orders.map((order) => {
        return <StoreItems key={order.storeId} order={order} cartType={cartType} />;
      })}
    </VStack>
  );
}
